<template>
  <div class="rank-page">
    <img src="../assets/bg.png" class="rank-bg" alt="" />
    <div class="rank-mask">
      <div class="rank-head">
        <div class="rank-venue">{{ venueName || '本场大屏' }}</div>
        <div class="rank-title">在场活跃榜</div>
        <div class="rank-sub">在场 {{ totalPresent }} 人 · {{ refreshSec }}s 刷新 · {{ clock }}</div>
      </div>

      <div v-if="top3.length" class="podium">
        <div
          v-for="row in podiumOrder"
          :key="'p-' + row.user_id"
          class="podium-item"
          :class="'p' + row.rank"
        >
          <div class="podium-badge">TOP {{ row.rank }}</div>
          <img class="podium-avatar" :src="row.avatar_url || defaultAvatar" alt="" />
          <div class="podium-nick">{{ row.nickname || '玩家' }}</div>
          <div class="podium-score">{{ row.score_label || (row.score + ' 分钟') }}</div>
          <div v-if="row.play_type" class="podium-play">想玩 {{ row.play_type }}</div>
        </div>
      </div>

      <div v-if="list.length" class="active-list">
        <div v-for="row in list" :key="row.user_id" class="active-row">
          <div class="active-rank">{{ row.rank }}</div>
          <img class="active-avatar" :src="row.avatar_url || defaultAvatar" alt="" />
          <div class="active-main">
            <div class="active-nick">{{ row.nickname || '玩家' }}</div>
            <div class="active-meta">
              <span v-if="row.play_type">{{ row.play_type }}</span>
              <span v-if="row.last_active_at">最近 {{ row.last_active_at }}</span>
            </div>
          </div>
          <div class="active-score">{{ row.score_label || row.score }}</div>
        </div>
      </div>
      <div v-else class="rank-empty">{{ emptyText }}</div>
    </div>
  </div>
</template>

<script>
import autofit from 'autofit.js'
import { presentActiveRank, getVenueInfo } from '@/api/team/index.js'

export default {
  name: 'RankActive',
  data() {
    return {
      venueId: 0,
      venueName: '',
      list: [],
      totalPresent: 0,
      clock: '',
      refreshSec: 15,
      timer: null,
      clockTimer: null,
      defaultAvatar: 'https://static.superyuwang.com/default/avatar.png',
      emptyText: '加载中…'
    }
  },
  computed: {
    top3() {
      return (this.list || []).slice(0, 3)
    },
    podiumOrder() {
      const t = this.top3
      if (t.length < 2) return t
      if (t.length === 2) return [t[1], t[0]]
      return [t[1], t[0], t[2]]
    }
  },
  created() {
    const q = this.$route.query || {}
    this.venueId = Number(q.venueId || q.venue_id || q.id || 0)
  },
  mounted() {
    autofit.init({ dh: 1080, dw: 1920, el: 'body', resize: true })
    this.tickClock()
    this.clockTimer = setInterval(this.tickClock, 1000)
    this.load()
    this.timer = setInterval(this.load, this.refreshSec * 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    if (this.clockTimer) clearInterval(this.clockTimer)
    try {
      autofit.off()
    } catch (e) {
      /* ignore */
    }
  },
  methods: {
    tickClock() {
      const d = new Date()
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`)
      this.clock = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    async load() {
      if (!this.venueId) {
        this.emptyText = '缺少 venueId，请用管理端复制的固定链接打开'
        this.list = []
        return
      }
      try {
        if (!this.venueName) {
          const { data: venue } = await getVenueInfo({ venue_id: this.venueId })
          this.venueName = (venue && venue.name) || ''
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const { data } = await presentActiveRank({
          venue_id: this.venueId,
          limit: 20
        })
        this.list = (data && data.list) || []
        this.totalPresent = (data && data.total_present) || this.list.length
        this.emptyText = this.list.length ? '' : '当前无人在场 · 扫码进场后会出现'
      } catch (e) {
        this.emptyText = '活跃榜加载失败，稍后自动重试'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rank-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: #fff;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}
.rank-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.rank-mask {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  height: 100%;
  padding: 36px 48px 40px;
  background: linear-gradient(180deg, rgba(8, 12, 28, 0.55), rgba(8, 12, 28, 0.85));
  display: flex;
  flex-direction: column;
}
.rank-head {
  display: flex;
  align-items: baseline;
  gap: 24px;
  margin-bottom: 20px;
}
.rank-venue {
  font-size: 28px;
  opacity: 0.85;
}
.rank-title {
  font-size: 48px;
  font-weight: 700;
}
.rank-sub {
  margin-left: auto;
  font-size: 22px;
  opacity: 0.65;
}
.podium {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 48px;
  min-height: 300px;
  margin: 8px 0 24px;
}
.podium-item {
  text-align: center;
  width: 220px;
}
.podium-item.p1 {
  transform: translateY(-28px);
}
.podium-badge {
  font-size: 20px;
  opacity: 0.8;
  margin-bottom: 8px;
}
.podium-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid rgba(255, 213, 106, 0.7);
  background: #222;
}
.p1 .podium-avatar {
  width: 150px;
  height: 150px;
  border-color: #ffd56a;
}
.podium-nick {
  margin-top: 12px;
  font-size: 26px;
  font-weight: 600;
}
.podium-score {
  margin-top: 6px;
  font-size: 24px;
  color: #7ec8ff;
}
.podium-play {
  margin-top: 4px;
  font-size: 18px;
  opacity: 0.7;
}
.active-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 8px 20px;
}
.active-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.active-rank {
  width: 40px;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
}
.active-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  background: #222;
}
.active-main {
  flex: 1;
  min-width: 0;
}
.active-nick {
  font-size: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.active-meta {
  margin-top: 4px;
  font-size: 18px;
  opacity: 0.6;
  display: flex;
  gap: 16px;
}
.active-score {
  font-size: 24px;
  color: #ffb347;
  font-weight: 600;
}
.rank-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  opacity: 0.7;
}
</style>
